import {Component} from '@angular/core'
import { NuclearObservable } from '../../nuclear-observable'
import { BaseComponent } from '../../components/base.component'
import {customerGetters} from '../../stores/customer-store'
import {Customer} from '../../types'
import { MediaQueryService } from '../../services/media-query-service'

@Component({
  selector: 'account-signup-clients-home-page',
  template: `
    <split-view>
      <div left>
        <div class="container-fluid" (window:resize)="isMobile">
          <div class="row mt-3">
            <div class="col-sm-12">
              <div class="nc-section-icon fas fa-user-plus"></div>
              <h1 class="nc-section-header">Add your client(s).</h1>
              <p id="client-home-subheader">
                <i class="fas fa-arrow--left small-right-buffer" [class.fa-arrow-left]="!isMobile" [class.fa-arrow-up]="isMobile"></i>
                <span *ngIf="customers.length === 0">
                  <span class="d-lg-none">
                    Select "Add your first client" from the clients dropdown above to begin.
                  </span>
                  <span class="d-none d-lg-inline">
                    Select "Add your first client" in the left pane to begin.
                  </span>
                </span>
                <span *ngIf="customers.length > 0">Add another client.</span>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div right>
      </div>
    </split-view>
  `
})
export class AccountSignupClientsHomePage extends BaseComponent {
  customers: Customer[];
  constructor(private mediaQueryService: MediaQueryService) {
    super()

    const custObs = NuclearObservable.from<Customer[]>(customerGetters.shallowCustomers, { toJS: true }).subscribe(cs => this.customers = cs || [])
    this.observers.push(custObs)
  }

  get isMobile(): boolean {
    return this.mediaQueryService.isUnder('lg')
  }

}
